import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { IEyeicon } from "../../../../../../../assets/icons/IEyeicon"
import intl from "react-intl-universal"
import { ChartLereyJennings } from "../ChartLereyJennings"
import Button from "../../../../../../atoms/Button"
import { TableAnalysis } from "../TableAnalysis"
import { fnFormatDateFromUTC } from "../../../../../../../utils/date"
import AuthContext from "../../../../../../../contexts/Auth"
import { useContext } from "react"
import { Drawer } from "../Drawer"

import styles from "./index.module.scss"
import { CALC_TYPES } from "../../../../constants"

export const LaunchAnalysis = ({
  bg,
  anlt_cname,
  anlt_nid,
  equipmentId,
  type,
  item,
  runs,
  idx,
}) => {
  const [selectedRun, setSelectedRun] = useState(null)
  const navigate = useNavigate()
  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone

  const [isOpen, setIsOpen] = useState(false)

  const redirectToReleaseDetails = () => {
    navigate(`/ciq/release/${equipmentId}/details/${item?.anlt_nid}`)
  }

  const runNumber = selectedRun?.eqpanltrun_number

  const cstatusSelected = selectedRun?.eqpanltrun_status.toLowerCase()

  const statusBtn = cstatusSelected?.startsWith("p")
    ? styles.btnPendind
    : cstatusSelected?.startsWith("r")
    ? styles.btnReject
    : styles.btnActive

  const fnRunDate = (date) => {
    const [data, hour] = fnFormatDateFromUTC(
      `${date}`,
      "DD/MM/YYYY - HH:mm",
      cUserTimeZone,
    ).split(" - ")

    return `${data} ${intl.get("ciq.to_the")} ${hour}`
  }

  const fnCalcRunDate = (date) => {
    if (!date) return ""

    return fnFormatDateFromUTC(date, "DD/MM/YYYY", cUserTimeZone)
  }

  const bIsQuantitative = type?.toLowerCase() === "quantitativo"
  const aAvailableLevels = item?.anlt_levels?.filter((l) => l?.bavailable) ?? []

  return (
    <div
      className={styles.containerGraphic}
      style={{
        background: bg ?? "#fff",
        borderTop: bg ? "1px solid #737D86" : "1px solid #737D86",
      }}
    >
      <div className={styles.containerIdentifyAnalyte}>
        <div className={styles.containerName}>
          <strong>{anlt_cname}</strong>
        </div>

        {bIsQuantitative && aAvailableLevels?.length > 0 && (
          <div className={`${styles.containerInfo} ${styles.analyteCalcContainer}`}>
            {aAvailableLevels.map((level) => {
              const {
                elevel,
                ccalc_type,
                manual_average_start_run_date,
                manual_average_end_run_date,
              } = level

              const cLabel =
                ccalc_type === CALC_TYPES.MANUAL_AVERAGE
                  ? intl.get("ciq.release_details.automatic_calculus_period", {
                      level: elevel,
                    })
                  : intl.get("ciq.release_details.manual_calculus_period", {
                      level: elevel,
                    })

              return (
                <div key={`analyte-calc-type-level-${elevel}`}>
                  <p>{cLabel}</p>
                  {ccalc_type === CALC_TYPES.MANUAL_AVERAGE && (
                    <p>
                      {fnCalcRunDate(manual_average_start_run_date)} -{" "}
                      {fnCalcRunDate(manual_average_end_run_date)}
                    </p>
                  )}
                </div>
              )
            })}
          </div>
        )}

        <Button
          stableIcon
          variant="outline"
          iconLeft={<IEyeicon fill="#6CB6E3" />}
          onClick={redirectToReleaseDetails}
        >
          {intl.get("ciq.see_details")}
        </Button>
      </div>

      {type === intl.get("ciq.types_analytes.quantitative") ? (
        <ChartLereyJennings
          anlt_nid={anlt_nid}
          runs={runs}
          setSelectedRun={setSelectedRun}
          setIsOpen={setIsOpen}
          className={styles.chartLereyJennings}
        />
      ) : (
        <TableAnalysis
          item={item}
          anlt_nid={anlt_nid}
          runs={runs}
          setSelectedRun={setSelectedRun}
          selectedRun={selectedRun}
          idx={idx}
          setIsOpen={setIsOpen}
        />
      )}

      <div className={styles.containerButtonRace}>
        {runNumber ? (
          <>
            <div className={styles.containerNumber}>
              <strong>
                {intl.get("ciq.release_details.run")} Nº {runNumber}{" "}
              </strong>
            </div>
            <Button className={statusBtn} onClick={() => setIsOpen(true)}>
              {selectedRun?.eqpanltrun_status.toLowerCase().startsWith("p")
                ? intl.get("ciq.status_race.pending")
                : selectedRun?.eqpanltrun_status.toLowerCase().startsWith("r")
                ? intl.get("ciq.status_race.disapproved")
                : intl.get("ciq.status_race.approved")}
            </Button>
          </>
        ) : (
          <p>{intl.get("ciq.not_launch")}</p>
        )}
        {isOpen && (
          <Drawer
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            eqpanltrun_nid={selectedRun?.eqpanltrun_nid}
            runNumber={runNumber}
            analyteName={anlt_cname}
            typeAnalyte={type}
          />
        )}
        {(selectedRun?.eqpanltrun_user || selectedRun?.eqpanltrun_drelease) && (
          <div className={styles.containerInfo}>
            {selectedRun?.eqpanltrun_user && (
              <>
                {selectedRun?.eqpanltrun_status.toLowerCase().startsWith("r") ? (
                  <p>{intl.get("ciq.reproved_by")}:</p>
                ) : (
                  <p>{intl.get("ciq.approved_by")}:</p>
                )}
              </>
            )}

            <p>
              {selectedRun?.eqpanltrun_user
                ? `${selectedRun?.eqpanltrun_user?.cname} ${intl.get("ciq.in")} `
                : ""}
              {selectedRun?.eqpanltrun_drelease
                ? fnRunDate(selectedRun.eqpanltrun_drelease)
                : ""}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
